import { ShipmentStopType } from "@api/graphql/generated/generated-types";
import { StopOrderItem, toStopOrderItems } from "./stopOrderRowRules";
import {
  StopOrderEditing,
  getCompletedStopIds,
  hasPendingStopOrderChange,
  isEntryNumberMode,
} from "./stopOrderRules";

interface GetStopOrderSaveProps {
  formStops: Array<{ id?: string; type: ShipmentStopType }>;
  savedStops: Array<{ id: string; completedAt?: number | null }>;
  stopOrderEditing?: StopOrderEditing;
}

/**
 * What a save does about the stop order: the stops as submitted, whether the dispatcher changed their
 * order, and whether it is saved as entry numbers. Where Confirm Route is the save, no numbers are sent.
 */
export function getStopOrderSave({
  formStops,
  savedStops,
  stopOrderEditing,
}: GetStopOrderSaveProps): {
  submittedStopOrderItems: StopOrderItem[];
  hasStopOrderChange: boolean;
  shouldSendEntryNumbers: boolean;
} {
  const submittedStopOrderItems: StopOrderItem[] = toStopOrderItems(
    formStops,
    getCompletedStopIds(savedStops),
  );
  const hasStopOrderChange: boolean = stopOrderEditing
    ? hasPendingStopOrderChange(stopOrderEditing.baselineStopIds, submittedStopOrderItems)
    : false;
  const shouldSendEntryNumbers: boolean =
    hasStopOrderChange && !!stopOrderEditing && isEntryNumberMode(stopOrderEditing.mode);
  return { submittedStopOrderItems, hasStopOrderChange, shouldSendEntryNumbers };
}
